export const ENDPOINTS_USER = {
  CHANGE_PASSWORD: '/bff-vle/users/:userId/password',
  CHANGE_PASSWORD_ME: '/bff-vle/me/change-password',
  CHECK_EMAIL: '/bff-vle/users/checkEmail?email=:email',
  CHECK_LOGIN: '/bff-vle/checkLogin',
  CHECK_PASSWORD_SECURITY: '/bff-vle/users/checkPasswordSecurity',
  CHECK_SCHOOL_ID: '/bff-vle/schools/:schoolId',
  CHECK_USERNAME: '/bff-vle/users/checkUsername',
  EDUBOOK_LEGAL_CONDITIONS: '/bff-vle/users/:userId/legalConditions',
  ME_CLASSROOMS: '/bk/me/classrooms',
  ME_CLASSROOMS_BFF: '/bff-vle/me/classrooms',
  ME_CLASSROOM_ID: '/bk/me/classroom/:classroomId',
  ME_CONFIGURATIONS: '/bff-vle/me/configurations',
  ME_COURSES: '/bk/me/courses',
  ME_COURSES_BFF: '/bff-vle/me/courses',
  ME_COURSE_ID: '/bk/me/course/:courseId',
  ME_DATA: '/bff-vle/me',
  ME_FEEDBACK_POOL: '/bff-vle/me/feedbackPool',
  ME_FIRSTSTEPS: '/bk/me/firstSteps',
  ME_LEGAL_CONDITIONS: '/bk/me/legalConditions',
  ME_PUBLISHER: '/bff-vle/me/publishers',
  ME_SCHOOL_ID: '/bk/me/school/:schoolCode',
  ME_SET_COURSE: '/bff-vle/me/courses/:courseId',
  PUBLISHER_LEGAL_CONDITIONS:
    '/bff-vle/users/:userId/publishers/:publisherId/legalConditions',
  RECOVER_PASSWORD: '/bff-vle/me/recoverPassword',
  RESET_PASSWORD: '/bff-vle/users/:userId/resetPassword',
  SCHOOL_CODE: '/bff-vle/schools/:schoolId/students/:userId',
  SYSTEM_CONFIGS: '/bff-vle/system/configs',
  TUTOR_IA_AUTONOMY_ID: '/bff-vle/me/tutoria?autonomyId=:autonomyId',
  TUTOR_IA_BOOK_ID: '/bff-vle/me/tutoria/books/:bookId',
  UNLINK_GOOGLE: '/bff-vle/ssoUser/:userId',
  USERS_ID_PROMOTIONTERMS: '/bff-vle/users/:userId/promotionTerms',
  USERS_ID_RESENDWELCOMEEMAIL: '/bk/users/:userId/resendWelcomeEmail',
  USERS_LOG_OUT: '/bff-vle/logout',
  USER_DATA_ID: '/bff-vle/users/:userId',
  USER_FLAG: '/bff-vle/users/:userId/usersFlags/:userFlagName',
}
